import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocusdataService } from "src/app/core/services/focusdata.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { Station } from "src/app/shared/models/focusDataModels/Station";
import { PrinterDeviceItem } from "src/app/shared/models/PrinterDevice.model";

@Component({
	selector: "app-printer-device-list",
	templateUrl: "./printer-device-list.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class PrinterDeviceListComponent implements OnInit {
	posStationList: Station[];
	printerDeviceList: PrinterDeviceItem[];
	printerDeviceSelected: PrinterDeviceItem;
	constructor(public app: AppService, private focuslink: FocuslinkService, public venueService: OOVenueService, private focusdata: FocusdataService) {}

	ngOnInit(): void {
		this.venueService.subscriptionVenueKey.subscribe((data) => {
			if (data && data !== 0) {
				this.getPrinterDevices(data);
			}
		});
	}

	async getPrinterDevices(venueKey: number) {
		const promiseList = [
			this.focuslink.printerDeviceGetAll(venueKey).then((data) => {
				this.printerDeviceList = data.map((i) => new PrinterDeviceItem(i));
			}),
			this.focusdata.stationsGet(venueKey).then((data) => {
				this.posStationList = data.map((i) => new Station(i));
			}),
		];

		await Promise.all(promiseList);

		this.printerDeviceList.forEach((i) => {
			i.controllingPosDeviceName = this.posStationList.find((x) => x.ID === i.controllingPosDeviceId)?.Name;
		});
	}

	newPrinterDeviceItem() {
		this.printerDeviceSelected = new PrinterDeviceItem({
			pk: `PRINTER_DEVICE_${this.venueService.venueKey}`,
		});
	}
}
